import { ResetStore, SetMembers, SetRoles } from '~/constants/mutations';
import {
  ClearStore,
  FetchMembers,
  FetchRoles,
  FetchUserData,
  InviteMembers,
  RemoveMembersRoles,
  TransferOwnership,
  UpdateMembersRoles,
} from '~/constants/actions';
import { endpoints } from '~/services/amplify-api/endpoints';
import { ROLE_RANK } from '~/constants';

const defaultState = () => {
  return {
    members: [],
    roles: [],
  };
};

export const state = defaultState;

export const mutations = {
  [ResetStore](state) {
    Object.assign(state, defaultState());
  },

  [SetMembers](state, members) {
    state.members = members;
  },

  [SetRoles](state, roles) {
    state.roles = roles;
  },

  [UpdateMembersRoles](state, data) {
    const { members, roles } = data;

    members.forEach((id) => {
      const index = state.members.findIndex((member) => member.id === id);
      const rolesData = state.roles.filter((role) => roles.includes(role.id));

      if (index !== -1) {
        state.members[index].roles = rolesData;
      }
    });
  },

  [RemoveMembersRoles](state, data) {
    const { members } = data;

    members.forEach((id) => {
      const index = state.members.findIndex((member) => member.id === id);

      if (index !== -1) {
        state.members.splice(index, 1);
      }
    });
  },
};

export const actions = {
  [ClearStore]({ commit }) {
    commit(ResetStore);
  },

  async [FetchMembers]({ commit }) {
    try {
      const { data } = await this.$amplifyApi.get(endpoints.organization.members);

      commit(SetMembers, data?.data ?? []);
    } catch (error) {
      console.error(error);
    }
  },

  async [InviteMembers]({ dispatch }, payload) {
    try {
      const { data } = await this.$amplifyApi.post(endpoints.organization.invite, payload);

      dispatch(FetchMembers);

      return data;
    } catch (error) {
      const { response: { data: { statusCode, message } = {} } = {} } = error;

      if (statusCode === 400) {
        this.$notification.toast({
          type: 'warning',
          title: message,
          closable: true,
        });
      }

      console.error(error);
    }
  },

  async [FetchRoles]({ commit }) {
    try {
      const { data } = await this.$amplifyApi.get(endpoints.role.base);

      // sort roles by rank
      const roles = (data?.data || []).sort((r1, r2) => ROLE_RANK[r1.name] - ROLE_RANK[r2.name]);

      commit(SetRoles, roles);
    } catch (error) {
      console.error(error);
    }
  },

  async [UpdateMembersRoles]({ commit, dispatch }, payload) {
    try {
      commit(UpdateMembersRoles, payload);

      await this.$amplifyApi.post(endpoints.organization.members, payload);

      dispatch(FetchMembers);
    } catch (error) {
      console.error(error);
    }
  },

  async [RemoveMembersRoles]({ commit, dispatch }, payload) {
    try {
      await this.$amplifyApi.delete(endpoints.organization.members, { data: payload });

      commit(RemoveMembersRoles, payload);
      dispatch(FetchMembers);
    } catch (error) {
      console.error(error);
    }
  },

  async [TransferOwnership]({ dispatch }, id) {
    try {
      await this.$amplifyApi.post(endpoints.organization.transfer, { toUserId: id });

      dispatch(FetchMembers);
      dispatch(`authStore/${FetchUserData}`, {}, { root: true });
    } catch (error) {
      console.error(error);
    }
  },
};

export const getters = {};
